"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var react_highlight_words_1 = tslib_1.__importDefault(require("react-highlight-words"));
var ExpandableTreeItem = function (_a) {
    var name = _a.name, value = _a.value, focusInput = _a.focusInput, selectedItemID = _a.selectedItemID;
    var _b = react_1.useState(true), isExpanded = _b[0], setIsExpanded = _b[1];
    var expand = function () {
        setIsExpanded(true);
    };
    var collapse = function () {
        setIsExpanded(false);
    };
    var expandChildren = react_1.useCallback(function (e) {
        e.preventDefault();
        var target = e.target;
        var parent = target === null || target === void 0 ? void 0 : target.closest('li.parent');
        var sibling = parent === null || parent === void 0 ? void 0 : parent.nextElementSibling;
        sibling === null || sibling === void 0 ? void 0 : sibling.classList.toggle('show');
    }, []);
    var toggleDisplay = react_1.useCallback(function (e) {
        if (isExpanded) {
            focusInput();
            collapse();
            expandChildren(e);
        }
        else {
            focusInput();
            expand();
            expandChildren(e);
        }
    }, [isExpanded]);
    return (react_1.default.createElement("li", { className: "parent", id: "parent", "data-testid": "parent" },
        react_1.default.createElement("button", { type: "button", onMouseDown: toggleDisplay },
            react_1.default.createElement("span", { className: "row-container" },
                react_1.default.createElement("i", { className: isExpanded ? 'icon--chevron_down' : 'icon--chevron_right' }),
                react_1.default.createElement("span", { className: "svg-icon" },
                    react_1.default.createElement("i", { className: isExpanded ? 'icon--folder_open' : 'icon--folder' })),
                !selectedItemID ? (react_1.default.createElement(react_highlight_words_1.default, { searchWords: [value], textToHighlight: name, className: "highlighted_tree_item", highlightClassName: "highlighted_tree_item", "data-testid": "highlighted-tree-item" })) : (react_1.default.createElement("span", null, name))))));
};
exports.default = ExpandableTreeItem;
